import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
export const ReactApp = ({ rootId = "root", renderedApp, providers = [], strictMode = true, }) => {
    const AppWithProvider = providers.reduce((appNode, ProviderComponent) => {
        return _jsx(ProviderComponent, { children: appNode });
    }, renderedApp);
    ReactDOM.createRoot(document.getElementById(rootId)).render(strictMode ? _jsx(React.StrictMode, { children: AppWithProvider }) : AppWithProvider);
};
